import React from 'react';
import {useForm, Controller} from 'react-hook-form';
import {
  Button,
  Grid,
  TextField,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import {IFdUser} from 'constants/interfaces';

export function FdUserForm(props: {
  user?: IFdUser;
  isLoading: boolean;
  submitButtonTitle: string;
  onSubmit: (user: Partial<IFdUser>) => any;
  cancelButtonTitle?: string;
  onCancel?: () => any;
  readonly?: boolean;
}) {
  type Submission = {
    name: string;
    surname: string;
    idNumber: string;
    email: string;
    phoneNumber: string;
  };

  const {handleSubmit, control} = useForm<Submission>({
    defaultValues: {
      ...props.user,
    },
  });

  const onSubmit = (data: Partial<Submission>) => {
    props.onSubmit(data);
  };

  return (
    <div className="generic-form-container fd-user-form">
      <div className="form-container">
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} className="form-section">
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                User Information
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="name"
                control={control}
                render={({field: {onChange, value}, fieldState: {error}}) => (
                  <TextField
                    className="input"
                    label="Name"
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    helperText={error ? error.message : null}
                    disabled={props.readonly || props.isLoading}
                  />
                )}
                rules={{
                  required: 'Name is required',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="surname"
                control={control}
                render={({field: {onChange, value}, fieldState: {error}}) => (
                  <TextField
                    className="input"
                    label="Surname"
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    helperText={error ? error.message : null}
                    disabled={props.readonly || props.isLoading}
                  />
                )}
                rules={{
                  required: 'Surname is required',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="idNumber"
                control={control}
                render={({field: {onChange, value}, fieldState: {error}}) => (
                  <TextField
                    className="input"
                    label="ID Number"
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    helperText={error ? error.message : null}
                    disabled={props.readonly || props.isLoading}
                  />
                )}
                rules={{
                  required: 'ID Number is required',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="email"
                control={control}
                render={({field: {onChange, value}, fieldState: {error}}) => (
                  <TextField
                    className="input"
                    label="Email"
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    helperText={error ? error.message : null}
                    disabled={props.readonly || props.isLoading}
                  />
                )}
                rules={{
                  required: 'Email is required',
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Invalid email address',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="phoneNumber"
                control={control}
                render={({field: {onChange, value}, fieldState: {error}}) => (
                  <TextField
                    className="input"
                    label="Phone Number"
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    helperText={error ? error.message : null}
                    disabled={props.readonly || props.isLoading}
                  />
                )}
                rules={{
                  required: 'Phone number is required',
                }}
              />
            </Grid>
          </Grid>
          {!props.readonly && (
            <Grid container spacing={2} style={{marginTop: '1rem'}}>
              <Grid item xs={12} sm={6}>
                {props.cancelButtonTitle && (
                  <Button
                    className="secondary-btn"
                    variant="contained"
                    fullWidth
                    disableElevation
                    disabled={props.isLoading}
                    onClick={props.onCancel}
                  >
                    {props.cancelButtonTitle}
                  </Button>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  className="primary-btn"
                  type="submit"
                  variant="contained"
                  fullWidth
                  disableElevation
                  color="primary"
                  disabled={props.isLoading}
                >
                  {props.isLoading ? (
                    <CircularProgress color="primary" size={24} thickness={6} />
                  ) : (
                    props.submitButtonTitle
                  )}
                </Button>
              </Grid>
            </Grid>
          )}
        </form>
      </div>
    </div>
  );
}
